module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Select all {total}":"Select all {total}","Deselect all {total}":"Deselect all {total}"},"de":{"Select all {total}":"Alle {total} auswählen","Deselect all {total}":"Alle {total} abwählen","Select all on this page":"Alle auf dieser Seite auswählen","Deselect all on this page":"Alle auf dieser Seite abwählen"}}')
  delete Component.options._Ctor
}
